import React, { Component } from 'react';
import { connect } from 'react-redux';

import HorizontalRule from '../common/horizontalRule';

class ManagedHorizontalRule extends Component {
  render() {
    return (
      <HorizontalRule
        style={this.props.style || {}}
        className="template-divider"
      />
    );
  }
}

const mapState = (state, ownProps) => {
  return {};
};

export const TemplateHorizontalRule = connect(mapState)(ManagedHorizontalRule);
